export const SET_LOGIN = 'SET_LOGIN';

export default {
  [SET_LOGIN]: (state, login) => {
    state.login = login;
  },
};
